import { Button } from '@pickleballinc/react-ui';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';
import clsx from 'clsx';

import { LinkType, ThemeInterface } from '@/types/homepage.types';

interface LinkButtonsWrapperProps {
  links?: LinkType[];
  alertTheme: ThemeInterface;
}
export const LinkButtonsWrapper = ({ links, alertTheme }: LinkButtonsWrapperProps) => {
  if (!links || !links.length) return null;

  return (
    <div className='flex w-full items-stretch items-center gap-1 mt-3'>
      {links.map((link) =>
        link.linkUrl && link.linkText ? (
          <CustomLink
            key={`button-link-${link.id}`}
            href={link.linkUrl}
            target='_blank'
            rel='noopener noreferrer'
            className='w-auto'
          >
            <Button
              variant='primary'
              size='xs'
              className={clsx(
                'flex h-full sm:h-auto w-auto min-w-[91px] justify-center !px-2 !py-1 hover:opacity-50 whitespace-normal break-words text-center',
                alertTheme.buttonBackgroundColor,
                alertTheme.buttonTextColor
              )}
            >
              {link.linkText}
            </Button>
          </CustomLink>
        ) : null
      )}
    </div>
  );
};
